 $('.buy-box').appendTo('#bundle-box-placeholder');
  $('.buy-box').unwrap();

var is_bundle_page = $('body').hasClass('template-collection-build-your-bundle');

  var discounts = [
    {
      'discount': 'Buy 2',
      'discount_percent': 10,
      'purchase_quantity_requirements': 2
    },
    {
      'discount': 'Buy 3',
      'discount_percent': 15,
      'purchase_quantity_requirements': 3
    }
  ]; 
  
  function getBundleItemCount() {
    var currentCount = 0;
    $('.bundled-products .item_qty').each(function(){
        currentCount += parseFloat($(this).text());
    });
    return currentCount;
  }
  
  function updateProgressBar() {
    var bar = $('.filled_progress'),
        maxProductsToAdd  = 3,
        steps = 2;
  
    $('.progress_msg').removeClass('active');
    if(getBundleItemCount() >= 3) {
      $('.progress_msg[current-count="3"]').addClass('active');
    }
    else {
      $('.progress_msg[current-count="' + getBundleItemCount() + '"]').addClass('active');
    }
    var progressPercent = getBundleItemCount() / maxProductsToAdd * 100;
    $('.filled_progress').css('width', progressPercent + '%');
    
    discounts.forEach(function(i, item) {
      if(item.purchase_quantity_requirements > getBundleItemCount()) {
         var to_add = item.purchase_quantity_requirements - getBundleItemCount();
          $('.progress_to_add').text(to_add);
      }
    });
  }

  updateProgressBar();

  // Function to collect all product data into a single object
  function collectProductData() {
    var products = {};
  
    $('.bundled-product-item').each(function () {
      var variantID = $(this).attr('variant-id');
        
      var productData = {
        quantity: parseInt($(this).find('.item_qty').text()),
        image: $(this).find('img').attr('Src'),
        productID: $(this).attr('product-id'),
        maxQuantity: $(this).attr('max'),
        productTitle: $(this).find('.title').text(),
        variantTitle: $(this).find('.variant-name').text(),
        originalPrice: parseInt($(this).find('.price').attr('data-price'))
      };
  
      products[variantID] = productData;
    });
  
    console.log('collectProductData', products, JSON.stringify(products));
    return JSON.stringify(products); // Return as a serialized JSON string
  }
  
  function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    const cookieString = `${name}=${encodeURI(value)}; ${expires}; path=/;`;
    console.log('Setting cookie:', cookieString);
    document.cookie = cookieString;
  }
  
  // Function to get a cookie value as a string
  function getCookie(name) {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();
      if (cookie.indexOf(nameEQ) === 0) {
        return decodeURI(cookie.substring(nameEQ.length)); // Return raw string
      }
    }
    return null; // Return null if the cookie is not found
  }
  
  function deleteCookie(name, path = '/', domain = '') {
    const domainString = domain ? `; domain=${domain}` : '';
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}${domainString};`;
  }

  // Save all product data as a string to cookies
  function saveProductsToCookies() {
    const productBundleData = collectProductData() // Collect data as a string
    deleteCookie('bundle_data')
    setCookie('bundle_data', productBundleData, 1); // Store as string

    setCookie('show_popup_save_bundle', true, 1); 
    
  }
  
  function removeBundlesFromCart() {
    console.log('TESTTESTTEST current_bundle', current_bundle)

    $('body').addClass('bundle-loading');
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates: current_bundle })
    })
    .then(response => {
      return response.json();
    })
    .then((data) => {
      console.log('Products updated:', data);
      $('body').removeClass('bundle-loading');
    })
    .catch((error) => {
      $('body').removeClass('bundle-loading');
      console.error('Error:', error);
    });
    
  }

  function retrieveProductsFromCookies() {
    const productBundleData = JSON.parse(getCookie('bundle_data'))
    
    $('.product--item .qtybox input').val(0)
  
    for (let variantID in productBundleData) {
      
      var data = productBundleData[variantID],
          priceFormatted =  Shopify.formatMoney((data.originalPrice * data.quantity), Shopify.money_format);
      
      var product = `
          <div class="bundled-product-item" product-id="${data.productID}" variant-id="${variantID}" max="${data.maxQuantity}">
          <img src="${data.image}">
          <div class="info_block">
            <div class="top_info">
              <div class="left_block">
                <h2 class="title">${data.productTitle}</h2>
                <span class="variant-name">${data.variantTitle}</span>
              </div>
              <div class="price-wrapper">
                <span class="line-compare-price"></span>
                <span class="price" data-price="${data.originalPrice}">${priceFormatted}</span>
              </div>
            </div>
            <div class="bottom_info">
              <div class="qty_selector">
                <span class="qty_change qty_minus">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.13867 9H14.1175" stroke="#676767" stroke-width="1.42555" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </span>
                <span class="item_qty">${data.quantity}</span>
                <span class="qty_change qty_plus">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.59684 4.00781V13.9866M3.60742 8.99723H13.5863" stroke="#676767" stroke-width="1.42555" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                </span>
              </div>
              <span class="remove">
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="-40 0 427 427.00131" width="20px"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"></path><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path></svg>
              </span>
            </div>
          </div>
        </div>`;
        
        $('.bundled-products').append(product); 
        $('.product--item[variant-id=' + variantID + '] .qtybox input').val(data.quantity)
    }
    if(getBundleItemCount() > 1) {
      $('.btn-bundle-toggle').addClass('active');
      $('.buy-box').addClass('box-open');
    }
    $('body').removeClass('bundle-loading');
    
    if(getBundleItemCount() > 1) {
      $('.bundle-box-submit').attr('disabled', false);
    }
    else {
      $('.bundle-box-submit').attr('disabled', true);
    }

    updateProgressBar();
    updateLinePrices();
  
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to fetch cart data');
        }
        return response.json();
      })
      .then((cart) => {
        const cartCount = cart.item_count;
        $('.js-cart-count').text(cartCount);
      })
      .catch((error) => {
        console.error('Error updating cart count:', error);
      });
  }

  function productsToAdd(products, redirectToCart) {
      if($('body').hasClass('template-cart')) {
        $('body').addClass('cart-updating')
      }

      console.log('products', products)
    
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: products }),
      })
      .then((response) => {
        if (!response.ok) {
          window.location.href = '/cart';
          deleteCookie('show_popup_save_bundle');
          setCookie('popup_cart_error', true, 1);
          throw new Error('Failed to add products to cart.');
        }
        return response.json();
      })
      .then((data) => {
        console.log('Products added to cart:', data);
        updateCartCount()
        deleteCookie('show_popup_save_bundle')
        if($('body').hasClass('template-cart')) {
      
          fetch('/cart?section_id=' + $('.cart-section-container').attr('id'))
          .then(response => response.text())
          .then(html => {
      
            var tempDiv = $('<div>').html(html);
            var cartForm = tempDiv.find('.cart-section-inner');
            
            console.log('Cart section fetched and updated!', cartForm);
            
            $('.cart-section-container').html(cartForm)
            
            $('body').removeClass('cart-updating')

            // setCookie('popup_bundle_notif_close', true, 1); 
            
          })
          .catch(error => {
            console.error('Error fetching the cart section:', error);
          });
        }
        else {
          if(redirectToCart) {
            window.location.href = '/cart'
          }
        }
        
        $('.popup-save-bundle').removeClass('active');
        
        deleteCookie('show_popup_save_bundle');
        console.log('delete show_popup_save_bundle', getCookie('show_popup_save_bundle'))
        // Optionally update cart UI or show a success message
      })
      .catch((error) => {
        $('body').removeClass('bundle-loading');
        console.error('Error adding products to cart:', error);
      });
      
  }

  function updateLinePrices() {
    $('.bundled-product-item').each(function() {
      var price = $(this).find('.price').attr('data-price'),
          quantity = parseInt($(this).find('.item_qty').text()),
          variantID = parseInt($(this).attr('variant-id'));

        var originalPrice = price * quantity,
            discountPercentage = 0; // 20%    
      
        if(getBundleItemCount() == 2) {
          discountPercentage = 10;
        }
        else if (getBundleItemCount() >= 3) {
          discountPercentage = 15;
        }
        
        var discountedPrice = originalPrice - (originalPrice * discountPercentage) / 100;
        var formattedDiscountedPrice = Shopify.formatMoney(discountedPrice, Shopify.money_format);

        if(getBundleItemCount() > 1) {
          $(this).find('.line-compare-price').text(Shopify.formatMoney(originalPrice, Shopify.money_format));
        }
        else {
          $(this).find('.line-compare-price').text('');
        }
      
        $(this).find('.price').text(formattedDiscountedPrice)
    });
  }
  
  function addToCart(variantID, quantity) {
        $('body').addClass('bundle-loading');


          var productItem = $('.product--item[variant-id="' + variantID + '"]'),
              image = $('.product--item[variant-id="' + variantID + '"]').attr('product-image'),
              productID = $('.product--item[variant-id="' + variantID + '"]').attr('product-id'),
              maxQuantity = $('.product--item[variant-id="' + variantID + '"] .quantity').attr('max'),
              productTitle = $('.product--item[variant-id="' + variantID + '"]').attr('product-title'),
             
              variantTitle =  $('option:selected', productItem.find('.product-select-variant')).attr('variant-title'),
              maxQuantity =  $('option:selected', productItem.find('.product-select-variant')).attr('max'),
              originalPrice =  $('option:selected', productItem.find('.product-select-variant')).attr('original-price'),
              priceFormatted =  Shopify.formatMoney((originalPrice * quantity), Shopify.money_format);

        
          var product = `
          <div class="bundled-product-item" product-id="${productID}" variant-id="${variantID}" max="${maxQuantity}">
            <img src="${image}">
            <div class="info_block">
              <div class="top_info">
                <div class="left_block">
                  <h2 class="title">${productTitle}</h2>
                  <span class="variant-name">${variantTitle}</span>
                </div>
                <div class="price-wrapper">
                  <span class="line-compare-price"></span>
                  <span class="price" data-price="${originalPrice}">${priceFormatted}</span>
                </div>
              </div>
              <div class="bottom_info">
                <div class="qty_selector">
                  <span class="qty_change qty_minus">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M4.13867 9H14.1175" stroke="#676767" stroke-width="1.42555" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                  </span>
                  <span class="item_qty">${quantity}</span>
                  <span class="qty_change qty_plus">
                  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M8.59684 4.00781V13.9866M3.60742 8.99723H13.5863" stroke="#676767" stroke-width="1.42555" stroke-linecap="round" stroke-linejoin="round"/> </svg>
                  </span>
                </div>
                <span class="remove">
                <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="-40 0 427 427.00131" width="20px"><path d="m232.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m114.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m28.398438 127.121094v246.378906c0 14.5625 5.339843 28.238281 14.667968 38.050781 9.285156 9.839844 22.207032 15.425781 35.730469 15.449219h189.203125c13.527344-.023438 26.449219-5.609375 35.730469-15.449219 9.328125-9.8125 14.667969-23.488281 14.667969-38.050781v-246.378906c18.542968-4.921875 30.558593-22.835938 28.078124-41.863282-2.484374-19.023437-18.691406-33.253906-37.878906-33.257812h-51.199218v-12.5c.058593-10.511719-4.097657-20.605469-11.539063-28.03125-7.441406-7.421875-17.550781-11.5546875-28.0625-11.46875h-88.796875c-10.511719-.0859375-20.621094 4.046875-28.0625 11.46875-7.441406 7.425781-11.597656 17.519531-11.539062 28.03125v12.5h-51.199219c-19.1875.003906-35.394531 14.234375-37.878907 33.257812-2.480468 19.027344 9.535157 36.941407 28.078126 41.863282zm239.601562 279.878906h-189.203125c-17.097656 0-30.398437-14.6875-30.398437-33.5v-245.5h250v245.5c0 18.8125-13.300782 33.5-30.398438 33.5zm-158.601562-367.5c-.066407-5.207031 1.980468-10.21875 5.675781-13.894531 3.691406-3.675781 8.714843-5.695313 13.925781-5.605469h88.796875c5.210937-.089844 10.234375 1.929688 13.925781 5.605469 3.695313 3.671875 5.742188 8.6875 5.675782 13.894531v12.5h-128zm-71.199219 32.5h270.398437c9.941406 0 18 8.058594 18 18s-8.058594 18-18 18h-270.398437c-9.941407 0-18-8.058594-18-18s8.058593-18 18-18zm0 0"></path><path d="m173.398438 154.703125c-5.523438 0-10 4.476563-10 10v189c0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10v-189c0-5.523437-4.476563-10-10-10zm0 0"></path></svg>
                </span>
              </div>
            </div>
          </div>`;
          
          $('.bundled-products').prepend(product); 
          $('.btn-bundle-toggle').addClass('active');
          $('.buy-box').addClass('box-open');
          $('body').removeClass('bundle-loading');
    
          if(getBundleItemCount() > 1) {
            $('.bundle-box-submit').attr('disabled', false);
          }
          else {
            $('.bundle-box-submit').attr('disabled', true);
          }
    
          updateProgressBar();
          updateLinePrices();
    
    saveProductsToCookies()
    
  }
   
  function updateQuantityToCart(variantID, quantity) {
    $('body').addClass('bundle-loading');
    
    var bundledItem = $('.bundled-product-item[variant-id="' + variantID + '"]');
    
    if(quantity == 0) {
      bundledItem.remove();
    }

    bundledItem.find('.item_qty').text(quantity)
    
    $('body').removeClass('bundle-loading');
    
    if(getBundleItemCount() > 1) {
      $('.bundle-box-submit').attr('disabled', false);
      
    }
    else {
      $('.bundle-box-submit').attr('disabled', true);
    }
    
    updateProgressBar();
    updateLinePrices();
    
    if(getBundleItemCount() > 0) {
      $('.buy-box').addClass('box-open');
    }
    
    saveProductsToCookies();
    if(getBundleItemCount() == 0) {
      removeBundlesFromCart()
    }
  }
  
  var url = new URL(window.location.href);
  var url_parameter_status = url.searchParams.get("status");
  var url_parameter_tag = url.searchParams.get("filter.p.tag");

  if(is_bundle_page) {
    if(getCookie('bundle_data') != null || getCookie('bundle_data') != '{}') {
      if( url_parameter_status == 'edit' || ((url_parameter_tag == 'Cat' || url_parameter_tag == 'Dog') && url_parameter_status == 'edit' )) {
        
      }
      else {
          $('.bundled-product-item').remove()   
          retrieveProductsFromCookies();
      }
    }
  }

function checkProductsAndQuantities(currentBundle, bundleData) {
  // ✅ First check if the number of products is the same
  if (Object.keys(currentBundle).length !== Object.keys(bundleData).length) {
    return false;
  }

  // ✅ Then check each product and quantity
  for (let id in bundleData) {
    if (bundleData.hasOwnProperty(id)) {
      var currentQuantity = currentBundle[id];
      var expectedQuantity = bundleData[id].quantity;

      if (currentQuantity === undefined || currentQuantity !== expectedQuantity) {
        return false;
      }
    }
  }
  return true;
}


  let total_quantity = 0;
  $.each(JSON.parse(getCookie('bundle_data')), function(key, value) {
    total_quantity += value.quantity;
  });
  
  if(is_bundle_page || total_quantity <= 1 ) {
    deleteCookie('show_popup_save_bundle')
  }

  if(getCookie('show_popup_save_bundle') == 'true' && !checkProductsAndQuantities(current_bundle_products, JSON.parse(getCookie('bundle_data')))) {


    $('.popup-save-bundle').addClass('active')
  }

  
  $('#build-your-bundle-sort').on('change', function() {
    window.location.href = this.value ;
  });
  
  $('.btn-bundle-toggle').on('click', function() {
    $('.buy-box').addClass('box-open');
  });
  
  $('.box-header .close').on('click', function() {
    $('.buy-box').removeClass('box-open');
  });
  
  $('.product-select-variant').on('change', function() {
    var productItem = $(this).closest('.product--item'),
        productItemQuantity = productItem.find('.quantity'),
        max = $('option:selected', this).attr('max'),
        price = $('option:selected', this).attr('price'),
        variantTitle = $('option:selected', this).attr('variant-title'),
        container = $(this).closest('.product--item');

    container.attr('variant-id', $(this).val());
    container.attr('variant-title', variantTitle);
    container.find('.price').text(price);
    container.find('.quantity').attr('max', max);
    
    var bundledItemQuantity = $('.bundled-product-item[variant-id="' + $(this).val() + '"] .item_qty').text() * 1;
    container.find('.quantity').val(bundledItemQuantity);
    
    productItem.find('.qtybox').attr('on-cart', productItemQuantity.val());    
    
  });

  $('.popup-save-bundle').on('click', function(e) {
    if (e.target !== this)
      return;
    $(this).removeClass('active');
    deleteCookie('show_popup_save_bundle')
  });
  
  // Close function for popup-exceeded-stock and popup-cart-error
  $('.popup-inner').parent().on('click', function(e) {
    if (e.target !== this)
      return;
    deleteCookie('popup_cart_error')
    $(this).removeClass('active');
  });
  
  $('.popup-inner .close').on('click', function() {
    deleteCookie('popup_cart_error')
    $(this).parent().parent().removeClass('active');
  });

  $('.bundle-box-submit').on('click', function(e) {
    e.preventDefault();
    
    var products = [];
  
    $('.bundled-product-item').each(function () {
      var variantID = parseInt($(this).attr('variant-id')),
          quantity = parseInt($(this).find('.item_qty').text());
        
      products.push({
        id: parseInt(variantID),
        quantity: quantity,
      });
    });

    if($('body').hasClass('has-bundle-in-cart')) {
      $('body').addClass('bundle-loading');
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: current_bundle })
      })
      .then(response => {
        return response.json();
      })
      .then((data) => {
        console.log('Products updated:', data);
        productsToAdd(products, true)
      })
      .catch((error) => {
        $('body').removeClass('bundle-loading');
        console.error('Error:', error);
      });
    }
    else {
        productsToAdd(products, true)
    }
    
  });

  $('.popup-save-bundle .close').on('click', function() {
    deleteCookie('bundle_data');
    deleteCookie('show_popup_save_bundle')
    $(this).parent().parent().removeClass('active');
  });

  $('#save-bundle').on('click', function(e) {
    e.preventDefault();
    
    $(this).addClass('loading')
    
    var productBundleData = JSON.parse(getCookie('bundle_data'))
    var products = [];
    
    Object.keys(productBundleData).forEach((variantID) => {
      console.log("ID:", variantID);
    
      products.push({
        id: parseInt(variantID),
        quantity: productBundleData[variantID].quantity
      });  
    });
    
    $('body').addClass('bundle-loading');

    if(Object.keys(bundle_products_to_remove).length > 0) {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ updates: bundle_products_to_remove })
      })
      .then(response => {
        return response.json();
      })
      .then((data) => {
        console.log('Products updated:', data);
        updateCartCount()
        productsToAdd(products, true)
      })
      .catch((error) => {
        $('body').removeClass('bundle-loading');
        console.error('Error:', error);
      });
    }
    else {
        productsToAdd(products, true)
    }
  });

  $('.product--item .quantity').on('focusin', function(){
      $(this).data('val', $(this).val());
  });

  $('.product--item .quantity').on('change', function() {
    
    var productItem = $(this).closest('.product--item'),
        productItemQuantity = parseInt($(this).val()),
        variantID = productItem.find('[name="id"]').val(),
        bundledItem = $('.bundled-product-item[variant-id="' + variantID + '"]'),
        maxQuantity = parseInt($(this).attr('max')),
        current_in_cart =  parseInt($('option:selected', productItem.find('.product-select-variant')).attr('total-items-in-cart'));
      
      var current_input_value = parseInt($(this).data('val'));
    console.log('current_input_value', current_input_value)
      if(current_in_cart >= maxQuantity) {
        $(this).val(current_input_value)
          $('.popup-exceeded-stock').addClass('active');
          return
      }

      if(productItemQuantity == 0 && bundledItem.length == 0) {
        return
      }
      if($(this).val() == '') {
        return
      }
    
      if(productItemQuantity > maxQuantity) {
        $(this).val(maxQuantity)
        $('.popup-exceeded-stock').addClass('active')
      }
      else {
        if(bundledItem.length == 0) {
          addToCart(variantID, productItemQuantity)
        }
        else {
            updateQuantityToCart(variantID, productItemQuantity)
        }
      }

    
      if($('.bundled-product-item').length == 0) {
        $('.buy-box').removeClass('box-open');
        $('.btn-bundle-toggle').removeClass('active'); 
      }
      productItem.find('.qtybox').attr('on-cart', productItemQuantity);
  });
  
  $('.product--item .add, .product--item .add-to-bundle').on('click', function() {
    var productItem = $(this).closest('.product--item'),
        productItemQuantity = productItem.find('.quantity'),
        variantID = productItem.find('[name="id"]').val(),
        bundledItem = $('.bundled-product-item[variant-id="' + variantID + '"]'),
        maxQuantity = parseFloat(productItemQuantity.attr('max')),
        current_in_cart =  parseInt($('option:selected', productItem.find('.product-select-variant')).attr('total-items-in-cart'));
    
    
    if(current_in_cart >= maxQuantity) {
        $('.popup-exceeded-stock').addClass('active');
        return
    }
    
    if (productItemQuantity.val() < maxQuantity) {
      productItemQuantity.val(+productItemQuantity.val() + 1);

      if(bundledItem.length == 0) {
        addToCart(variantID, productItemQuantity.val())
      }
      else {
        updateQuantityToCart(variantID, productItemQuantity.val())
      }
      productItem.find('.qtybox').attr('on-cart', productItemQuantity.val());
    }
    else {
      $('.popup-exceeded-stock').addClass('active')
    }

    
  });
  
  $('.product--item .sub').on('click', function() {
    var productItem = $(this).closest('.product--item'),
        productItemQuantity = productItem.find('.quantity'),
        variantID = productItem.find('[name="id"]').val(),
        bundledItem = $('.bundled-product-item[variant-id="' + variantID + '"]');
    
    if (productItemQuantity.val() > 0) {
      productItemQuantity.val(+productItemQuantity.val() - 1);
    }
    
    productItemQuantity.change();
    
    if (productItemQuantity.val() == 0)  {
      $('.bundled-product-item[variant-id="' + variantID + '"]').remove();
    }

    if (productItemQuantity.val() > 0) {
      if($('.bundled-product-item').length == 0) {
        $('.buy-box').removeClass('box-open');
        $('.btn-bundle-toggle').removeClass('active'); 
      }
  
      if(bundledItem.length > 0) {
        updateQuantityToCart(variantID, productItemQuantity.val())
      }

    }

    productItem.find('.qtybox').attr('on-cart', productItemQuantity.val());
    
  });
  
  $(document).on('click', '.bundled-product-item .remove', function() {
    var bundledItem = $(this).closest('.bundled-product-item'),
        variantID = bundledItem.attr('variant-id'),
        productItem = $('.product--item[variant-id="' + variantID + '"]'),
        bundledItemQuantity = bundledItem.find('.item_qty').text();
    
    productItem.find('.quantity').val(0)
    $(this).closest('.bundled-product-item').remove();
    
    if($('.bundled-product-item').length == 0) {
      $('.buy-box').removeClass('box-open');
      $('.btn-bundle-toggle').removeClass('active'); 
    }
    
    updateQuantityToCart(variantID, 0)
    productItem.find('.qtybox').attr('on-cart', 0);

    
  });
  
  $(document).on('click', '.bundled-product-item .qty_plus', function() {
    var bundledItem = $(this).closest('.bundled-product-item'),
        bundledItemQuantity = bundledItem.find('.item_qty'),
        variantID = parseInt(bundledItem.attr('variant-id')),
        maxQuantity = parseInt(bundledItem.attr('max')),
        productItem = $('.product--item[variant-id="' + variantID + '"]'),
        productItemQuantity = productItem.find('.quantity');
    
    if (parseInt(bundledItemQuantity.text()) < maxQuantity) {
        
      if (parseInt(bundledItemQuantity.text()) <= maxQuantity) {
        bundledItemQuantity.text(+bundledItemQuantity.text() + 1);
        productItemQuantity.val(+productItemQuantity.val() + 1);
      }
      updateQuantityToCart(variantID, parseInt(bundledItemQuantity.text()))
      productItem.find('.qtybox').attr('on-cart', productItemQuantity.val());
    }
    else {
      $('.popup-exceeded-stock').addClass('active')
    }
  });
  
  $(document).on('click', '.bundled-product-item .qty_minus', function() {
   var  bundledItem = $(this).closest('.bundled-product-item'),
        bundledItemQuantity = bundledItem.find('.item_qty'),
        variantID = bundledItem.attr('variant-id'),
        productItem = $('.product--item[variant-id="' + variantID + '"]'),
        productItemQuantity = productItem.find('.quantity');
  
    if (parseInt(bundledItemQuantity.text()) > 0) {
      bundledItemQuantity.text(+bundledItemQuantity.text() - 1);
      productItemQuantity.val(+productItemQuantity.val() - 1);
    }
    if (parseInt(bundledItemQuantity.text()) == 0) {
      bundledItem.remove();
    }
    if($('.bundled-product-item').length == 0) {
      $('.buy-box').removeClass('box-open');
      $('.btn-bundle-toggle').removeClass('active'); 
    }
    updateQuantityToCart(variantID, parseFloat(bundledItemQuantity.text()))
    productItem.find('.qtybox').attr('on-cart', productItemQuantity.val());    
  });


if($('.bundled-product-item').length > 0) {
  $('.buy-box').addClass('not-empty').addClass('box-open');
  $('.btn-bundle-toggle').addClass('active')
}
else {
  $('.buy-box').removeClass('not-empty').removeClass('box-open');
  $('.btn-bundle-toggle').removeClass('active')
}

$('body').removeClass('bundle_page_loading');

if(getCookie('popup_cart_error') == 'true') {
  $('.popup-cart-error').addClass('active');
}